import MentoringCrew from './MentoringCrew.vue';

export * from './types';
export default MentoringCrew;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/teamcard/components/crew/index.ts